import styled from '@emotion/styled'

export const SVGWrapper = styled.div`
  /*
* Centering all SVG images has some problems, but
* overall it works in the majority of situations and
* was decided by the designers and developers to be
* the best overall decision, as left-aligning images
* with content can look a little strange.
*/
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 100%;
    max-width: ${(props) => props.maxWidth};
  }
`
